export default {
  namespaced: true,
  state: {
    selectedTab: 'Actions',
    isLoading: false,
    additionalActionsOpen: false
  },
  mutations: {
    SET_SELECTED_TAB(state, tab) {
      state.selectedTab = tab
    },
    SET_LOADING(state, isLoading) {
      state.isLoading = isLoading
    },
    SET_ADDITIONAL_ACTIONS_OPEN(state, isOpen) {
      state.additionalActionsOpen = isOpen
    }
  },
  actions: {
    selectTab({ commit }, tab) {
      commit('SET_SELECTED_TAB', tab)
    },
    setLoading({ commit }, isLoading) {
      commit('SET_LOADING', isLoading)
    },
    toggleAdditionalActions({ commit, state }) {
      commit('SET_ADDITIONAL_ACTIONS_OPEN', !state.additionalActionsOpen)
    }
  },
  getters: {
    selectedTab: state => state.selectedTab,
    isLoading: state => state.isLoading,
    additionalActionsOpen: state => state.additionalActionsOpen
  }
}
